import * as Styled from '../styled'
import { memo } from 'react'
import { LoadingGradient } from 'common-components/LoadingGradient'
import { isImagePath } from 'utils/media'

interface ITrackItemLoadingProps {
  progress: number | null
  mediaPath?: string | null
  thumbnail?: string | null
  isItemGenerating: boolean
}

export const TrackItemLoading = memo(
  ({
    mediaPath,
    thumbnail,
    progress,
    isItemGenerating
  }: ITrackItemLoadingProps) => {
    const imageUrl = thumbnail || (isImagePath(mediaPath) ? mediaPath : null)
    const thumbComponent = imageUrl ? (
      <Styled.Thumbnail $bgImageUrl={imageUrl} $blurred />
    ) : (
      <Styled.ThumbnailSkeletonBg />
    )
    return (
      <>
        {thumbComponent}
        {isItemGenerating && (
          <LoadingGradient
            progress={progress ?? null}
            size="small"
            position="absolute"
          />
        )}
      </>
    )
  }
)

TrackItemLoading.displayName = 'TrackItemLoading'
